import React, { useState, useEffect } from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Hero from '../../../components/commons/hero/hero.component';
import ExecGrid from '../../../components/about/cta/cta-grid/exec-grid/cta-grid.component';
import heroImageSrc from '../../../images/about/policiesHero.svg';
import { getExecutiveCommiteePageData } from '../../../js/api/about/_executive-commitee.data';
import Loader from '../../../components/commons/helpers/loader/loader.component';

function ExecCom({ page: { MainContent } }) {
  // #RP - Task - Bind data to Executive Commitee Form in Front-End.
  const [responseMainContent, setResponseMainContent] = useState({});
  const [responseDropDownContent, setResponseDropDownContent] = useState({});
  const [status, setStatus] = useState(null);
  const [noContent] = useState(204);

  useEffect(() => {
    const fetchData = async () => {
      const getResponse = await getExecutiveCommiteePageData();

      if (getResponse) {
        setStatus(getResponse.status);
        setResponseMainContent(getResponse.MainContent);
        setResponseDropDownContent(getResponse.DropDownContent);
      }
    };
    fetchData();
  }, []);

  if (
    status == noContent ||
    (responseMainContent &&
      responseDropDownContent &&
      responseDropDownContent.Author != undefined)
  ) {
    return (
      <div className="exec-container">
        <Hero
          src={
            status != noContent && responseMainContent.HeaderImage_src
              ? responseMainContent.HeaderImage_src
              : ''
          }
          mobileImgSrc={
            status != noContent && responseMainContent.HeaderMobileImage_src
              ? responseMainContent.HeaderMobileImage_src
              : ''
          }
          alt={
            status != noContent && responseMainContent.HeaderImage_alt
              ? responseMainContent.HeaderImage_alt
              : ''
          }
          title={
            status != noContent && responseMainContent.Title
              ? responseMainContent.Title
              : 'Please contact admin for page content'
          }
          description={
            status != noContent && responseMainContent
              ? responseMainContent.HeaderContent
              : ''
          }
          template="landing"
          colorCategory="executive"
        />

        <div className="trinity-container">
          <ExecGrid
            onlySmallCtas
            data={responseDropDownContent}
            mainData={responseMainContent}
            status={status}
            url={MainContent.url}
          />
        </div>
      </div>
    );
  }
  return <Loader />;
}

export default ExecCom;
